export const load = () => ({
	h1: 'IndowONE Lifetime Commercial Warranty',
	title: 'IndowONE Lifetime Coverage For Commercial Use',
	description:
		"Understand what is and isn't covered by the Indow Windows lifetime warranty for residential projects.",
	showTitle: false,
});
